import { VtexButton } from '../../../styleguide/VtexButton';
import { useLogin } from '../../Login/hooks/useLogin';

function LoginContentButton(): JSX.Element {
	const { accessCodeTitle } = useLogin();

	return (
		<div className="vtex-login-2-x-button button vtex-login-2-x-accessCodeOptionBtn accessCodeOptionBtn">
			<VtexButton variation="secondary" block handleClick={() => undefined}>
				<span>{accessCodeTitle}</span>
			</VtexButton>
		</div>
	);
}

export default LoginContentButton;
